import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import React, { useEffect, useState } from "react";
import ShareSpaceItemDisplay from "./share-space-item-display";
import { ToastManager } from "utilities/toast/toast-manager";
import { t } from "utilities/localization-utils";
import ShareSpaceItemRecord from "models/view-models/share-spaces/share-space-item-record";
import Loader from "atoms/loaders/loader";
import { ShareSpaceUtils } from "utilities/share-spaces/share-space-utils";

export interface ShareSpaceItemDisplayListProps {
    guid: string;
    title?: string;
}

const CSS_BASE_CLASS = "c-share-space-item-display-list";

const ShareSpaceItemDisplayList: React.FC<ShareSpaceItemDisplayListProps> = (
    props: ShareSpaceItemDisplayListProps
) => {
    const { guid, title = "" } = props;

    const [shareSpaceItems, setShareSpaceItems] = useState<
        ShareSpaceItemRecord[]
    >([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getShareSpaceItems = async () => {
            setLoading(true);
            try {
                const response =
                    await ShareSpaceUtils.GetItemsByRecipientGuid(guid);
                setShareSpaceItems(response);
            } catch {
                ToastManager.error(
                    t("errors-actionResource", {
                        action: t("loading"),
                        resource: t("share"),
                    })
                );
            } finally {
                setLoading(false);
            }
        };
        getShareSpaceItems();
    }, [guid]);

    return (
        <section className={CSS_BASE_CLASS}>
            {loading && (
                <div className={`${CSS_BASE_CLASS}__loader`}>
                    <Loader
                        accessibleText={t("loadingItem", { item: "share" })}
                    />
                </div>
            )}
            {title && (
                <Heading
                    priority={HeadingPriority.Two}
                    cssClassName={`${CSS_BASE_CLASS}__title`}>
                    {title}
                </Heading>
            )}
            <div className={`${CSS_BASE_CLASS}__items`}>
                {shareSpaceItems.map((item) => (
                    <ShareSpaceItemDisplay key={item.id} item={item} />
                ))}
            </div>
        </section>
    );
};

export default ShareSpaceItemDisplayList;
